import { accountEntityName } from '../../../../../../backend/features/accounts/shared';
import { ImportDialogCard } from '../../../../../../ui/features/accounts/components/AccountsPanel/components/ImportDialogCard';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { formatDateCustom } from '@juvare/common-web-ui/utils';
import { showEntityImportDialog } from '@juvare/platform-sdk-react/ui/features/entity-import';
import DataArrayIcon from '@mui/icons-material/DataArray';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
export function showAccountImportDialog(t, csvTemplate) {
    const groupName = t('import.importGroupName', {
        date: formatDateCustom(new Date(), "MMM d yyyy HH:mm:ss 'GMT'XXX"),
    });
    const handleOnAfterImport = (groupName) => {
        showInfoSnackbar({
            message: t('import.groupCreatedMessage', { groupName: groupName }),
        });
    };
    showEntityImportDialog({
        entity: accountEntityName,
        options: {
            dialogTitle: t('panels.accounts.importCsvFile'),
            csvTemplateName: t('import.accountsTemplateFileName'),
            csvTemplate: csvTemplate,
            onAfterImport: () => handleOnAfterImport(groupName),
            additionalDialogContent: (React.createElement(Box, null,
                React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(ImportDialogCard, { title: t('import.additionalText.requiredFields'), description: React.createElement(Typography, { variant: 'body2', sx: { color: themeColors.text.subtle } },
                                t('import.additionalText.requiredFieldsDescription'),
                                " (",
                                React.createElement("span", { style: { color: 'red' } }, "*"),
                                ")."), icon: React.createElement(WarningAmberIcon, { sx: { color: themeColors.icon.main } }) })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(ImportDialogCard, { title: t('import.additionalText.blankFields'), description: t('import.additionalText.blankFieldsDescription'), icon: React.createElement(DataArrayIcon, { sx: { color: themeColors.icon.main } }) })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(ImportDialogCard, { title: t('import.additionalText.deletingData'), description: t('import.additionalText.deletingDataDescription'), icon: React.createElement(DeleteForeverOutlinedIcon, { sx: { color: themeColors.icon.main } }) })),
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(ImportDialogCard, { title: t('import.additionalText.overwritingData'), description: t('import.additionalText.overwritingDataDescription'), icon: React.createElement(DriveFileRenameOutlineOutlinedIcon, { sx: { color: themeColors.icon.main } }) }))))),
            metadata: { addImportedUsersToGroup: true, groupName },
        },
    });
}
